import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import * as $ from 'jquery';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private router:Router) {
  }

  ngOnInit() {
  }

  toggleOpen($event) {
    var div = $($event.target).closest("div.card").find('.toggle');
    div.slideDown("slow");
  }

  toggleClose($event) {
    var div = $($event.target).closest("div.card").find('.toggle');
    div.slideUp();
  }

  routeTo($event) {
    this.router.navigateByUrl($event.target.dataset.route);
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/home/home.component.ts